import React from "react";

function IconSignForSale(props) {
  return (
    <svg
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      {...props}>
      <path
        d="M7.04 16.894c-.897 0-1.448-.41-1.452-1.08h.942c.011.21.227.346.546.346.279 0 .464-.124.464-.314 0-.157-.127-.232-.49-.298l-.448-.08c-.62-.107-.958-.463-.958-1.01 0-.688.546-1.134 1.392-1.134.834 0 1.404.44 1.41 1.09h-.909c-.007-.204-.215-.358-.48-.358-.258 0-.427.117-.427.304 0 .162.139.256.462.312l.462.08c.659.114.963.426.963.975 0 .73-.553 1.167-1.476 1.167Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.387 16.8h-1.088l-.173-.673h-1.03l-.18.673h-.98l1.102-3.382h1.247l1.102 3.382Zm-1.744-2.552h-.047l-.321 1.179h.677l-.309-1.18Z"
        fill="currentColor"
      />
      <path
        d="M15.321 15.99h-1.378v-2.572h-.994V16.8h2.372v-.81ZM16.929 16.012h1.392v.788h-2.386v-3.382h2.386v.788H16.93v.548h1.305v.712H16.93v.546Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.636 1.764a.9.9 0 0 0-1.272 0L5.627 7.5H2.4a.9.9 0 0 0-.9.9v13.2a.9.9 0 0 0 .9.9h19.2a.9.9 0 0 0 .9-.9V8.4a.9.9 0 0 0-.9-.9h-3.227l-5.737-5.736ZM12 3.673 15.827 7.5H8.173L12 3.673ZM3.3 20.7V9.3h17.4v11.4H3.3Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default IconSignForSale;
